<template>
  <base-list-management
    ref="baseListManagement"
    :configData.sync="configData"
  />
</template>
<script>
import configDataFn from './config'
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import selectOption from '@/store/dict/selectOptionDict'
import CARDICT from '@/store/dict/carDict.js'

export default {
  name: 'comeOutRecord',
  props: {
    carId: {
      type: [String, Number],
      default: '',
    },
    modelId: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    const { configData } = configDataFn.call(this)
    return {
      // src/baseData/outInStoreRecord/manageList.js有引用
      // eslint-disable-next-line vue/no-unused-properties
      style: {
        customerName: 'float: left; width: 60px; height: 35px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;',
        customerTel: 'float: left; color: #8492a6; font-size: 13px; margin: 0; padding-left: 10px;',
      },
      oLoading: {
        fuzzySearch: false,
      },
      configData,
      searchData: {},
    }
  },
  computed: {
    // 是否上传验车单
    isWhetherList() {
      return this.dictParseList(selectOption.isWhetherList)
    },
    // 出入库类类型
    outInTypeList() {
      return this.dictParseList(CARDICT.OUT_INT_TYPE(), true)
    },
  },
  mounted() {
    this.getIsWhetherList()
    this.getOutInTypeList()
  },
  methods: {
    // 搜索逻辑 config.js有调用
    // eslint-disable-next-line vue/no-unused-properties
    dealWithData(val) {
      // 是否上传验车单
      if (val.hasInspection !== '') {
        val.hasInspection = Boolean(val.hasInspection)
      }

      val.tabNo = 0
      const obj = {
        plateNo: Number(this.carId),
        carId: this.carId,
        modelId: this.modelId,
      }
      Object.assign(val, obj)
      this.searchData = val
      return val
    },
    // 获取用户列表 src/baseData/outInStoreRecord/manageList.js有引用
    // eslint-disable-next-line vue/no-unused-properties
    async getCustomerList(query) {
      if (query.length < 1) return
      // 开启远程搜索
      this.oLoading.fuzzySearch = true
      searchByCustomerNameSensitive({
        customerState: 1,
        mixedType: 'YES',
        customerName: query,
      }).then(({ code, data = [] }) => {
        if (code === 1) {
          this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'customerId', data })
        }
      }).finally(() => {
        this.oLoading.fuzzySearch = false
      })
    },
    // 出入库详情页面 config.js有调用
    // eslint-disable-next-line vue/no-unused-properties
    goOutInDetails(row) {
      this.$router.push({
        path: '/vehicle/vehicleManage/detail',
        query: {
          tabType: 'comeOutRecord',
          id: row.id,
          carId: row.carId,
        },
      })
    },
    // 是否上传验车单
    getIsWhetherList() {
      this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'hasInspection', data: this.isWhetherList })
    },
    // 设置出入库类型
    getOutInTypeList() {
      this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'type', data: this.outInTypeList })
    },
  },
}
</script>
<style scoped lang="scss">
.export-box {
  display: inline-block;
  margin-left: 8px;
}
</style>
